import {useQueries} from "@tanstack/react-query";
import materialStorageService from "../../../../services/web/material-storage-service.js";
import materialService from "../../../../services/web/material-service.js";
import materialGroupService from "../../../../services/web/material-group-service.js";

const UseFetchOptions = ({
    fetchStorage = false,
    fetchMaterials = false,
    fetchGroups = false,
    fetchStorageByUser = false
}) => {
    const queries = useQueries({
        queries: [
            {
                queryKey: ['materials-storage'],
                queryFn: () => materialStorageService.options(),
                enabled: fetchStorage,
            },
            {
                queryKey: ['materials'],
                queryFn: () => materialService.optionsNonUnique(),
                enabled: fetchMaterials,
            },
            {
                queryKey: ['materials-groups'],
                queryFn: () => materialGroupService.options(),
                enabled: fetchGroups,
            },
            {
                queryKey: ['materials-storage-by-user'],
                queryFn: () => materialStorageService.optionsByUser(),
                enabled: fetchStorageByUser,
            }
        ]
    });

    return {
        storageOptions: queries[0].data,
        materialOptions: queries[1].data,
        groupsOptions: queries[2].data,
        storageByUserOptions: queries[3].data,
        isLoadingStorageByUserOptions: queries[3].isLoading,
        isErrorStorageByUserOptions: queries[3].isError,
        refetchStorageByUserOptions: queries[3].refetch,
    };
}

export default UseFetchOptions;
